import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { denormaliseEmojiServiceResponse, emojiRequest } from './EmojiUtils';

/**
 * Emoji providers should return JSON in the format defined by EmojiServiceResponse.
 */
var EmojiLoader = /*#__PURE__*/function () {
  function EmojiLoader(config) {
    _classCallCheck(this, EmojiLoader);
    this.config = config;
  }

  /**
   * Returns a promise with an array of Emoji from all providers.
   */
  return _createClass(EmojiLoader, [{
    key: "loadEmoji",
    value: function loadEmoji() {
      var emojisPromise = emojiRequest(this.config);
      return emojisPromise.then(function (emojiServiceResponse) {
        return denormaliseEmojiServiceResponse(emojiServiceResponse);
      });
    }
  }]);
}();
export { EmojiLoader as default };